import { render, staticRenderFns } from "./LiveEdit.vue?vue&type=template&id=36261089&"
import script from "./LiveEdit.vue?vue&type=script&lang=js&"
export * from "./LiveEdit.vue?vue&type=script&lang=js&"
import style0 from "./LiveEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports